// extracted by mini-css-extract-plugin
export default {"trigger":"select_trigger__oRAqK","content":"select_content__q3jSV","viewport":"select_viewport__IGvP8","item":"select_item__14Lfb","check":"select_check__hgm69"};